import { theme } from '@/styles/theme';
import { getInitials } from '@/utils/getInitials';
import { Avatar } from '@mui/material';

interface CustomAvatarProps {
  name?: string;
  src?: string;
}

export const CustomAvatar = ({ name, src }: CustomAvatarProps) => {
  const style = styles(src != '' && src != null && src != undefined);
  return (
    <Avatar src={src} alt={name} sx={style.avatar}>
      {!src && getInitials(name || '')}
    </Avatar>
  );
};

const styles = (src: boolean) => {
  return {
    avatar: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      border: src ? '1px' : '1px solid #D2232A',
      width: 48,
      height: 48,
      fontSize: '2rem',
    },
  };
};
